import { BaseModel } from './base.model';

export class AcsAuthModel extends BaseModel {
  static CONNECTION_STATUS_CONNECTED = 'connected';
  static CONNECTION_STATUS_DISCONNECTED = 'disconnected';

  instanceId?: number;
  resourceName?: string;
  connectionString?: string;
  connectionStatus?: string;

  get childModels(): {} {
    return {
    };
  }

  get unsafeApiAttributes() {
    return [];
  }

  toApi(model?: this): {} {
    return {
      ...super.toApi(model),
    };
  }
}
